module.exports = __webpack_public_path__ + "img/nfc-neutral.7f7cc5d2.svg";